import { useState } from "react"
import AddAddress from "./AddAddress/AddAddress"
import ContactDetails from "./ContactDetails/ContactDetails"
import classes from "./MyInfo.module.scss"

export default function MyInfo() {
  const [addAddress, setAddAddress] = useState(false)
  return (
    <div>
      <div className={classes.Heading}>My Info</div>
      {addAddress ? <AddAddress setAddAddress={setAddAddress} addAddress={addAddress} /> : <ContactDetails setAddAddress={setAddAddress} />}
    </div>
  )
}
